import { render, staticRenderFns } from "./OTPAuth.vue?vue&type=template&id=ac21bf50&scoped=true"
import script from "./OTPAuth.vue?vue&type=script&lang=js"
export * from "./OTPAuth.vue?vue&type=script&lang=js"
import style0 from "./OTPAuth.vue?vue&type=style&index=0&id=ac21bf50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac21bf50",
  null
  
)

export default component.exports